module.exports = __webpack_public_path__ + "media/images/sp/lp/bg-presentAmazon-left-8ab4805ebdb37687f8904fe571946206.png";